import { useEffect, useState } from "react";
import useToken from "../../hooks/useToken";

import { API_BASE_URL } from "../../APIs/APIConfig";


import StudentHome from "./StudentHome";
import StudentLogin from "./StudentLogin";
import LoadingCircle from "../../components/LoadingCircle";

import { encryptData, decryptData } from "../../utils/EncryptionUtils";


export default function StudentIndex() {

    const { token, saveToken, removeToken, isSessioned, setIsSessioned } = useToken();

    const [student, setStudent] = useState(null);

    const login = async (formData) => {

        const res = await fetch(API_BASE_URL + '/api/token',
            {
                method: 'POST',
                headers: {
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(
                    {
                        enc: encryptData(formData)
                    }
                ),
            })
        
        const eData = await res.json()
        const data = decryptData(eData['enc'])

        if (data['message'] === 'success'){
            saveToken(eData['access_token'])
        }
        else{
            alert(' Error : ' + data.error)
        }

    }

    const logout = async () => {

        await fetch(API_BASE_URL + '/api/logout',
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type':'application/json'
            },
        }).then((res) => {
            if (res.status === 200) {
                removeToken()
                setStudent(null)
            }
        })
    }

    useEffect( ()=>{
        if(token){
            setIsSessioned(true)
        }
        if(isSessioned && !student){
            const studentFetcher = async () => {
                const res = await fetch(`${API_BASE_URL}/student`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ' + token,
                            'Content-Type':'application/json'
                        },
                    })
                
                const eData = await res.json()
                const data = decryptData(eData['enc'])
                
                return data
                
            }
            const fetchStudentData = async () => {
                const fetchedStudent = await studentFetcher();
                setStudent(fetchedStudent);
              };
          
              fetchStudentData();
        }
    }, [student, setStudent, token, saveToken, isSessioned, setIsSessioned ])


    return (
        <>
        {isSessioned && student && <StudentHome student={student} setStudent={setStudent} logout={logout} token={token} saveToken={saveToken}/>}
        {isSessioned && !student && <div className='w-100 h-100'><LoadingCircle /></div>}
        {!isSessioned && <StudentLogin login={login} />}
        </>
    )
            
}